// DataTables core + Bootstrap 5 integration
require('datatables.net');
require('datatables.net-bs5');

// DataTables Buttons + Bootstrap 5 integration
require('datatables.net-buttons');
require('datatables.net-buttons-bs5');
require('datatables.net-buttons/js/buttons.html5');

// DataTables FixedHeader + Bootstrap 5 integration
require('datatables.net-fixedheader');
require('datatables.net-fixedheader-bs5');

// FixedColumns
require('datatables.net-fixedcolumns');
require('datatables.net-fixedcolumns-bs5');

// DataTables CSS (Bootstrap 5)
import 'datatables.net-bs5/css/dataTables.bootstrap5.css';
import 'datatables.net-buttons-bs5/css/buttons.bootstrap5.css';
import 'datatables.net-fixedheader-bs5/css/fixedHeader.bootstrap5.css';
import 'datatables.net-fixedcolumns-bs5/css/fixedColumns.bootstrap5.css';
